
import './App.css';
import { Provider } from 'react-redux'
import store from './Redux/store'
import Header from "./componentes/Header";
import { BrowserRouter, Route,  Routes, } from 'react-router-dom'
import About from "./componentes/About"
import Empleouno from "./componentes/Experiencias/Empleouno"
import Empleodos from "./componentes/Experiencias/Empleodos"
import Empleotres from "./componentes/Experiencias/Empleotres"
import Empleocuatro from "./componentes/Experiencias/Empleocuatro"
import Empleocinco from "./componentes/Experiencias/Empleocinco"
import Portafolio from "./componentes/Portafolio"
import Blog from "./componentes/Blog"
import Home from "./componentes/Home"
import Contacto from "./componentes/Contacto"
import   "./style.css";


function App() {
  return (
    <Provider store={store}>
          <div className="App">
            
        
            
            <BrowserRouter>
            <Header />
                  <Routes>
                      <Route path='/' element={<Home/>} />
                      <Route path='/about' exact element={< About/>} />
                       <Route path='/porta' exact element={<Portafolio />} />
                       <Route path='/empleouno' exact element={<Empleouno />} />
                       <Route path='/empleodos' exact element={<Empleodos />} />
                       <Route path='/empleotres' exact element={<Empleotres />} />
                       <Route path='/empleocuatro' exact element={<Empleocuatro />} />
                       <Route path='/empleocinco' exact element={<Empleocinco />} />
                       <Route path='/blog' exact element={<Blog/>} />
                       <Route path='/contacto' exact element={<Contacto/>} />
                      
                  </Routes>
            </BrowserRouter>
        
          </div>
    </Provider> 
  );
}

export default App;
